import { useState } from 'react';
import { LayoutGrid, Network, RotateCcw, Upload, Route } from 'lucide-react';
import { useEntrance } from './context/entrance-context';
import { EntranceFilterBar } from './shared/entrance-filter-bar';
import { EntranceStats } from './shared/entrance-stats';
import { EntranceGraph } from './graph/entrance-graph';
import { EntranceListView } from './list/entrance-list-view';
import { SeedImportModal } from './shared/seed-import-modal';
import { PathFinderPanel } from './pathing/ui/path-finder-panel';

export function EntranceTrackerPage() {
  const { state, setViewMode, reset } = useEntrance();
  const [showImport, setShowImport] = useState(false);
  const [showPathing, setShowPathing] = useState(false);

  return (
    <div className="flex flex-col h-[calc(100vh-7rem)]">
      {/* Header */}
      <div className="flex flex-col gap-2 mb-3">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-bold text-zelda-gold">Entrance Tracker</h1>
          <div className="flex items-center gap-2">
            {/* Import */}
            <button
              onClick={() => setShowImport(true)}
              className="px-2 py-1 text-xs text-gray-400 hover:text-zelda-gold border border-gray-700 rounded flex items-center gap-1"
            >
              <Upload size={12} />
              Import
            </button>
            {/* Pathing */}
            <button
              onClick={() => setShowPathing(!showPathing)}
              className={`px-2 py-1 text-xs border border-gray-700 rounded flex items-center gap-1 ${
                showPathing
                  ? 'bg-zelda-gold/20 text-zelda-gold border-zelda-gold/30'
                  : 'text-gray-400 hover:text-zelda-gold'
              }`}
            >
              <Route size={12} />
              Pathing
            </button>
            {/* View toggle */}
            <div className="flex bg-gray-800 rounded border border-gray-700">
              <button
                onClick={() => setViewMode('graph')}
                className={`px-2 py-1 text-xs flex items-center gap-1 rounded-l ${
                  state.viewMode === 'graph'
                    ? 'bg-zelda-gold/20 text-zelda-gold'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <Network size={14} />
                Graph
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`px-2 py-1 text-xs flex items-center gap-1 rounded-r ${
                  state.viewMode === 'list'
                    ? 'bg-zelda-gold/20 text-zelda-gold'
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                <LayoutGrid size={14} />
                List
              </button>
            </div>
            <button
              onClick={reset}
              className="px-2 py-1 text-xs text-gray-400 hover:text-red-400 border border-gray-700 rounded flex items-center gap-1"
            >
              <RotateCcw size={12} />
              Reset
            </button>
          </div>
        </div>
        <EntranceFilterBar />
        <EntranceStats />
      </div>

      {/* Content */}
      <div className="flex-1 rounded-lg border border-gray-800 overflow-hidden flex">
        <div className={`${showPathing ? 'flex-1' : 'w-full'} overflow-hidden`}>
          {state.viewMode === 'graph' ? <EntranceGraph /> : <EntranceListView />}
        </div>
        {showPathing && (
          <div className="w-80 flex-shrink-0">
            <PathFinderPanel onClose={() => setShowPathing(false)} />
          </div>
        )}
      </div>

      {/* Import modal */}
      {showImport && <SeedImportModal onClose={() => setShowImport(false)} />}
    </div>
  );
}
